import script from "./EsqueciSenha.vue?vue&type=script&setup=true&lang=js"
export * from "./EsqueciSenha.vue?vue&type=script&setup=true&lang=js"

import "./EsqueciSenha.vue?vue&type=style&index=0&id=1a32a88f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a32a88f"]])

export default __exports__